import {ActivatedRoute, Router} from '@angular/router';
import {CommonDataService} from '../../shared/services/common-data.service';
import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {DataTable} from 'primeng/primeng';

@Component({
    selector: 'app-order-summary',
    templateUrl: './order-summary.component.html',
    styleUrls: ['./order-summary.component.css']
})
export class OrderSummaryComponent implements OnInit {

    @ViewChild(('dt')) dt: DataTable;
    @Input() orders: any [] = [];

    // Grid properties
    pageNumRows = 50;
    firstResult = 0;
    totalRecords: number;

    constructor(private router: Router,
                private route: ActivatedRoute,
                private commonDataService: CommonDataService) {
    }

    ngOnInit(): void {}

    orderDetails(order) {
        this.router.navigate(['campaigns', 'orderdetails', order.id]);
    }

    filter() {
        this.dt.filterDelay = -1;
    }

    reset() {
        this.dt.filterDelay = this.commonDataService.dataTableFilterDelay;
    }

}



// WEBPACK FOOTER //
// ./src/app/campaign/order-summary/order-summary.component.ts